export default __webpack_public_path__ + "static/media/header_1.68e55b0e.jpg";